import { gql } from '@apollo/client';

const TASK_DELETE = gql`
  mutation TaskDelete($input: TaskDeleteInput!) {
    taskDelete(input: $input) {
      errors {
        error
        message
      }
      deletedId
    }
  }
`;

export default TASK_DELETE;
